/* loaded by smart-asset */
export default require("./assets/pallet-case-item.i.svg")